import { ax } from '../utils/axios/axios'
import { BASE_API_URL } from '../constants'

export interface SwitchOffShift {
  drsId: number,
  date: string,
  status: string,
  project: string,
  depot: string | null,
  crew: string | null,
  inUkg: boolean,
}

export interface SwitchOffPreview {
  shifts: SwitchOffShift[],
  crews: string[],
}

export const apiLabourDeactivatePreview = (serialId: number) => {
  const options = {
    method: 'GET',
    url: `${BASE_API_URL}/labour`,
    params: {
      deactivatePreview: serialId,
    },
  }
  return ax(options)
}

export const apiLabourDeactivate = (serialId: number) => {
  const options = {
    method: 'PUT',
    url: `${BASE_API_URL}/labour`,
    params: {
      deactivate: serialId,
    },
  }
  return ax(options)
}
